// extracted by mini-css-extract-plugin
export default {"root":"admin_root__3R2HC"};